<template>
  <div class="p-6 w-full h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between">
      <p class="text-3xl font-bold">Team</p>
      <div class="flex flex-row items-center justify-between space-x-4">
        <div class="relative group">
          <input
            type="text"
            v-model="searchText"
            class="bg-light-gray px-4 py-3 rounded-full font-sans"
            placeholder="Search"
            v-on:keyup.enter="handleSearch"
          />
          <MagnifyingGlassIcon
            class="absolute bottom-3 right-3 w-6 h-6 text-gray"
          />
        </div>
        <BaseRoundedButton @click="handleSection">
          <p class="font-sans">Create Section</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleAssign">
          <p class="font-sans">Assing Bord Member</p>
        </BaseRoundedButton>
      </div>
    </div>
    <!-- body -->
    <div>
      <table class="table-auto w-full">
        <thead class="border-b-2 border-light-gray">
          <tr class="text-left text-gray text-lg">
            <th class="py-2 font-normal">Profile</th>
            <th class="py-2 font-normal">Name</th>
            <th class="py-2 font-normal text-center">Email</th>
            <th class="py-2 font-normal">Title</th>
            <th class="py-2 font-normal">Create at</th>
            <th class="py-2 font-normal text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="section in borderMembers" :key="section.id">
            <tr class="text-lg">
              <td colspan="5" class="py-3">
                <div class="flex space-x-2 items-center justify-between">
                  <h1 class="font-bold text-xl">{{ section.name }}</h1>
                  <p
                    v-if="section.show"
                    class="px-3 py-1 bg-light-blue text-blue rounded-full"
                  >
                    Shown
                  </p>
                  <p
                    v-else
                    class="px-3 py-1 bg-light-red text-red rounded-full"
                  >
                    hidden
                  </p>
                </div>
              </td>
              <td>
                <div class="flex justify-center relative">
                  <Menu>
                    <MenuButton
                      ><EllipsisVerticalIcon
                        class="
                          w-8
                          h-8
                          text-black
                          hover:text-blue
                          cursor-pointer
                        "
                    /></MenuButton>
                    <MenuItems
                      class="
                        p-1
                        space-y-1
                        absolute
                        top-8
                        right-8
                        z-50
                        bg-white
                        border border-light-gray
                        shadow-md
                        rounded-lg
                        w-12/12
                      "
                    >
                      <MenuItem
                        @click="handleEditSection(section)"
                        class="
                          hover:bg-light-blue
                          m-1
                          rounded-md
                          cursor-pointer
                        "
                      >
                        <div
                          class="flex flex-row items-center px-4 py-2 min-w-min"
                        >
                          <PencilIcon class="text-blue w-5 h-5 mr-4" />
                          <p class="text-blue">Edit</p>
                        </div>
                      </MenuItem>
                      <MenuItem
                        @click="handleReorderSection"
                        class="
                          hover:bg-light-blue
                          m-1
                          rounded-md
                          cursor-pointer
                        "
                      >
                        <div
                          class="flex flex-row items-center px-4 py-2 min-w-max"
                        >
                          <ArrowsUpDownIcon class="text-blue w-5 h-5 mr-4" />
                          <p class="text-blue">Reorder Board Section</p>
                        </div>
                      </MenuItem>
                      <MenuItem
                        @click="handleDelSection(section.id)"
                        class="
                          hover:bg-light-blue
                          m-1
                          rounded-md
                          cursor-pointer
                        "
                      >
                        <div
                          class="flex flex-row items-center px-4 py-2 min-w-min"
                        >
                          <TrashIcon class="text-red w-5 h-5 mr-4" />
                          <p class="text-red">Delete</p>
                        </div>
                      </MenuItem>
                    </MenuItems>
                  </Menu>
                </div>
              </td>
            </tr>
            <tr
              v-for="member in section.leader"
              :key="member.id"
              class="text-lg"
            >
              <td>
                <img
                  class="rounded-full w-14 h-14 object-cover mb-2"
                  :src="member.user.profile"
                  alt=""
                />
              </td>
              <td>{{ member.user.first_name }} {{ member.user.last_name }}</td>
              <td>{{ member.user.email }}</td>
              <td class="text-blue">{{ member.title }}</td>
              <td>
                {{
                  moment(member.user.created_at).format("MMM DD, YYYY h:mm A")
                }}
              </td>
              <td>
                <div class="flex justify-center relative">
                  <Menu>
                    <MenuButton
                      ><EllipsisVerticalIcon
                        class="
                          w-8
                          h-8
                          text-black
                          hover:text-blue
                          cursor-pointer
                        "
                    /></MenuButton>
                    <MenuItems
                      class="
                        p-1
                        space-y-1
                        absolute
                        top-8
                        right-8
                        z-50
                        bg-white
                        border border-light-gray
                        shadow-md
                        rounded-lg
                        w-12/12
                      "
                    >
                      <MenuItem
                        @click="handleEditMember(member.id)"
                        class="
                          hover:bg-light-blue
                          m-1
                          rounded-md
                          cursor-pointer
                        "
                      >
                        <div
                          class="flex flex-row items-center px-4 py-2 min-w-min"
                        >
                          <PencilIcon class="text-blue w-5 h-5 mr-4" />
                          <p class="text-blue">Edit</p>
                        </div>
                      </MenuItem>
                      <MenuItem
                        v-show="section.leader.length > 1"
                        @click="handleReorderLeader(section)"
                        class="
                          hover:bg-light-blue
                          m-1
                          rounded-md
                          cursor-pointer
                        "
                      >
                        <div
                          class="flex flex-row items-center px-4 py-2 min-w-max"
                        >
                          <ArrowsUpDownIcon class="text-blue w-5 h-5 mr-4" />
                          <p class="text-blue">Reorder Board Member</p>
                        </div>
                      </MenuItem>
                      <MenuItem
                        @click="handleRemoveMember(member.id)"
                        class="
                          hover:bg-light-blue
                          m-1
                          rounded-md
                          cursor-pointer
                        "
                      >
                        <div
                          class="flex flex-row items-center px-4 py-2 min-w-min"
                        >
                          <TrashIcon class="text-red w-5 h-5 mr-4" />
                          <p class="text-red">Delete</p>
                        </div>
                      </MenuItem>
                    </MenuItems>
                  </Menu>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
  <!-- create/update section slide over side bar -->
  <SideBar v-show="sectionSlideOver" @close-modal="handleSection">
    <div class="w-full h-full flex flex-col content-between">
      <h1 v-if="!updateFlag" class="text-blue text-2xl">Create New Section</h1>
      <h1 v-else class="text-blue text-2xl">Update Section</h1>
      <!-- form field -->
      <div class="mt-8 space-y-2">
        <BaseTextInput
          v-model="sectName"
          name="sectName"
          isAutoComplete="off"
          label="Section Name"
        />
        <div class="relative">
          <Listbox v-model="sectVisibility">
            <ListboxButton class="w-full">
              <div>
                <p class="text-left text-gray mb-2">Show/Hide</p>
                <div
                  class="
                    flex
                    items-center
                    justify-between
                    w-full
                    px-2
                    py-3
                    rounded-xl
                    border border-dark-gray
                  "
                >
                  <p v-if="sectVisibility == '0'" class="text-blue">Hide</p>
                  <p v-if="sectVisibility == '1'" class="text-blue">Show</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray" />
                </div>
              </div>
            </ListboxButton>
            <Transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-out"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <ListboxOptions
                class="
                  absolute
                  py-2
                  w-full
                  bg-white
                  rounded-lg
                  shadow-md
                  border border-light-gray
                "
              >
                <ListboxOption
                  v-for="(option, index) in visibleOption"
                  :key="index"
                  :value="index"
                  class="hover:bg-light-gray px-4 py-2 font-sans font-md"
                >
                  {{ option }}
                </ListboxOption>
              </ListboxOptions>
            </Transition>
          </Listbox>
        </div>
      </div>
      <!-- action button -->
      <div class="flex flex-row items-center justify-between space-x-4 mt-auto">
        <BaseRoundedButton @click="handleSection" class="bg-dark-gray w-2/6">
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton
          v-if="!updateFlag"
          @click="handleCreateSect"
          class="w-4/6"
        >
          <p>Create</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleUpdateSection" v-else class="w-4/6">
          <p>Update</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
  <!-- assign member section slide over side bar -->
  <SideBar
    v-show="assignSlideOver"
    @close-modal="this.assignSlideOver = !this.assignSlideOver"
  >
    <div class="w-full h-full flex flex-col content-between">
      <h1 v-if="!updateFlagMem" class="text-blue text-2xl">
        Assign Member to Board Section
      </h1>
      <h1 v-else class="text-blue text-2xl">Edit Board Member Title</h1>
      <!-- form field -->
      <div class="mt-8 space-y-4">
        <!-- Selecte board member -->
        <div v-if="!updateFlagMem" class="space-y-2">
          <p class="text-gray">Member</p>
          <Combobox v-model="selectedPerson">
            <div class="relative mt-1">
              <div class="relative w-full">
                <ComboboxInput
                  v-if="selectedPerson"
                  :displayValue="
                    (person) => person.first_name + ' ' + person.last_name
                  "
                  @change="query = $event.target.value"
                  class="
                    w-full
                    px-2
                    py-3
                    rounded-xl
                    border border-dark-gray
                    cursor-default
                  "
                />
                <ComboboxInput
                  v-else
                  @change="query = $event.target.value"
                  class="
                    w-full
                    px-2
                    py-3
                    rounded-xl
                    border border-dark-gray
                    cursor-default
                  "
                />
              </div>
              <ComboboxOptions
                class="
                  absolute
                  mt-1
                  max-h-96
                  w-full
                  overflow-auto
                  rounded-md
                  bg-white
                  py-2
                  text-base
                  shadow-lg
                  ring-1 ring-black ring-opacity-5
                  focus:outline-none
                  z-50
                "
              >
                <div
                  v-if="filteredMember.length === 0 && query !== ''"
                  class="relative cursor-default select-none p-2 text-gray-700"
                >
                  Member Not found.
                </div>
                <ComboboxOption
                  v-for="member in filteredMember"
                  :key="member.id"
                  :value="member"
                  v-slot="{ selected, active }"
                >
                  <li
                    class="relative cursor-pointer select-none py-2 pl-10 pr-4"
                    :class="{
                      'bg-light-blue text-blue': active,
                      'text-gray': !active,
                    }"
                  >
                    <span
                      class="block truncate"
                      :class="{
                        'font-medium': selected,
                        'font-normal': !selected,
                      }"
                    >
                      {{ member.first_name }} {{ member.last_name }}</span
                    >
                  </li>
                </ComboboxOption>
              </ComboboxOptions>
            </div>
          </Combobox>
        </div>
        <!-- title -->
        <div class="relative">
          <Listbox v-model="title">
            <ListboxButton class="w-full">
              <div>
                <p class="text-left text-gray mb-2">Title</p>
                <div
                  class="
                    flex
                    items-center
                    justify-between
                    w-full
                    px-2
                    py-3
                    rounded-xl
                    border border-dark-gray
                  "
                >
                  <p v-if="!title" class="text-left text-gray">Select title</p>
                  <p v-else class="text-blue">{{ title.title }}</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray" />
                </div>
              </div>
            </ListboxButton>
            <Transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-out"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <ListboxOptions
                class="
                  absolute
                  z-10
                  py-2
                  w-full
                  bg-white
                  rounded-lg
                  shadow-md
                  border border-light-gray
                "
              >
                <ListboxOption
                  v-for="title in titleList"
                  :key="title.id"
                  :value="title"
                  class="hover:bg-light-gray px-4 py-2 font-sans font-md"
                >
                  {{ title.title }}
                </ListboxOption>
              </ListboxOptions>
            </Transition>
          </Listbox>
        </div>
        <!-- section -->
        <div v-if="!updateFlagMem" class="relative">
          <Listbox v-model="section">
            <ListboxButton class="w-full">
              <div>
                <p class="text-left text-gray mb-2">Section</p>
                <div
                  class="
                    flex
                    items-center
                    justify-between
                    w-full
                    px-2
                    py-3
                    rounded-xl
                    border border-dark-gray
                  "
                >
                  <p v-if="!section" class="text-left text-gray">
                    Select section
                  </p>
                  <p v-else class="text-blue">{{ section.name }}</p>
                  <ChevronDownIcon class="w-4 h-4 text-gray" />
                </div>
              </div>
            </ListboxButton>
            <Transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-out"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <ListboxOptions
                class="
                  absolute
                  py-2
                  w-full
                  bg-white
                  rounded-lg
                  shadow-md
                  border border-light-gray
                "
              >
                <ListboxOption
                  v-for="section in borderMembers"
                  :key="section.id"
                  :value="section"
                  class="hover:bg-light-gray px-4 py-2 font-sans font-md"
                >
                  {{ section.name }}
                </ListboxOption>
              </ListboxOptions>
            </Transition>
          </Listbox>
        </div>
      </div>
      <!-- action button -->
      <div class="flex flex-row items-center justify-between space-x-4 mt-auto">
        <BaseRoundedButton
          @click="this.assignSlideOver = !this.assignSlideOver"
          class="bg-dark-gray w-2/6"
        >
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton
          v-if="!updateFlagMem"
          @click="handleAssingSection"
          class="w-4/6"
        >
          <p>Assign</p>
        </BaseRoundedButton>
        <BaseRoundedButton v-else @click="handleUpdatetitle" class="w-4/6">
          <p>Save</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
  <!-- reorder section side bar -->
  <SideBar v-show="orderSection" @close-modal="handleReorderSection">
    <div class="w-full h-full flex flex-col content-between">
      <!-- header -->
      <div>
        <h1 class="text-blue text-2xl">Reorder Board Section</h1>
        <p class="text-gray font-light">
          To reorder board section order, drag section card to any order.
        </p>
      </div>
      <!-- body -->
      <div class="my-8">
        <draggable
          class="list-group"
          tag="ul"
          :list="borderMembers"
          v-bind="dragOptions"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <div
            v-for="section in borderMembers"
            :key="section.id"
            class="my-2 cursor-move select-none"
          >
            <div
              class="
                px-2
                py-4
                w-full
                bg-white
                border-2 border-light-gray
                shadow-sm
                rounded-xl
                flex
                justify-between
                items-center
              "
            >
              <div>
                <p class="text-md">{{ section.name }}</p>
              </div>
              <div class="flex items-center space-x-2">
                <p
                  v-if="section.show"
                  class="px-3 py-1 bg-light-blue text-blue rounded-full"
                >
                  Shown
                </p>
                <p v-else class="px-3 py-1 bg-light-red text-red rounded-full">
                  hidden
                </p>
                <ArrowsUpDownIcon class="text-blue w-5 h-5" />
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <!-- action button -->
      <div class="flex flex-row items-center justify-between space-x-4 mt-auto">
        <BaseRoundedButton
          @click="handleReorderSection"
          class="bg-dark-gray w-2/6"
        >
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleOrderSection" class="w-4/6">
          <p>Save</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
  <!-- reorder board leader side bar -->
  <SideBar v-show="orderLeader" @close-modal="handleReorderLeader">
    <div class="w-full h-full flex flex-col content-between">
      <!-- header -->
      <div>
        <h1 class="text-blue text-2xl">
          Reorder Board Member for {{ tempData.name }}
        </h1>
        <p class="text-gray font-light">
          To reorder board member order, drag member card to any order.
        </p>
      </div>
      <!-- body -->
      <div class="my-8">
        <draggable
          class="list-group"
          tag="ul"
          :list="tempData.leader"
          v-bind="dragOptions"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <div
            v-for="leader in tempData.leader"
            :key="leader.id"
            class="my-2 cursor-move select-none"
          >
            <div
              class="
                px-2
                py-4
                w-full
                bg-white
                border-2 border-light-gray
                shadow-sm
                rounded-xl
                flex
                justify-between
                items-center
              "
            >
              <div>
                <div class="flex space-x-4">
                  <img
                    :src="leader.user.profile"
                    class="w-12 h-12 rounded-full object-cover"
                    alt=""
                  />
                  <div class="space-y-1">
                    <p class="text-md">
                      {{ leader.user.first_name }} {{ leader.user.last_name }}
                    </p>
                    <p class="text-gray font-light">{{ leader.title }}</p>
                  </div>
                </div>
              </div>
              <div class="flex items-center">
                <ArrowsUpDownIcon class="text-blue w-5 h-5" />
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <!-- action button -->
      <div class="flex flex-row items-center justify-between space-x-4 mt-auto">
        <BaseRoundedButton
          @click="handleReorderLeader"
          class="bg-dark-gray w-2/6"
        >
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleOrderLeader" class="w-4/6">
          <p>Save</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
</template>

<script>
import {
  MagnifyingGlassIcon,
  EllipsisVerticalIcon,
  PencilIcon,
  TrashIcon,
  ChevronDownIcon,
  ArrowsUpDownIcon,
} from "@heroicons/vue/24/outline";
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
import {
  Menu,
  MenuButton,
  MenuItems,
  MenuItem,
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
  Combobox,
  ComboboxInput,
  ComboboxOptions,
  ComboboxOption,
} from "@headlessui/vue";
import moment from "moment";
import userService from "../Services/user.service";
import SideBar from "../components/SideBar.vue";
import BaseTextInput from "../components/BaseTextInput.vue";
import { useToast } from "vue-toastification";
import { VueDraggableNext } from "vue-draggable-next";
export default {
  name: "Team",
  components: {
    BaseRoundedButton,
    MagnifyingGlassIcon,
    EllipsisVerticalIcon,
    PencilIcon,
    TrashIcon,
    ChevronDownIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    SideBar,
    BaseTextInput,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    draggable: VueDraggableNext,
    ArrowsUpDownIcon,
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      sectionSlideOver: false,
      assignSlideOver: false,
      orderSection: false,
      orderLeader: false,
      borderMembers: [],
      sectName: "",
      sectVisibility: "",
      updateFlag: false,
      updateFlagMem: false,
      updateId: "",
      visibleOption: ["Hide", "Show"],
      title: "",
      section: "",
      titleList: [],
      tempData: [],
      allMembers: [],
      memberMeta: [],
      params: new URLSearchParams(),
      query: "",
      selectedPerson: "",
      tempUpdateID: "",
    };
  },
  methods: {
    getTeamMember() {
      userService.getBordMember().then((response) => {
        this.borderMembers = response.data.data;
      });
    },
    getTitleList() {
      userService.getTitle().then((response) => {
        this.titleList = response.data.data;
      });
    },
    handleSection() {
      this.sectionSlideOver = !this.sectionSlideOver;
      this.updateFlag = false;
      this.sectName = "";
    },
    handleAssign() {
      if (this.allMembers.length <= 0) {
        this.handleGetAllData(this.memberMeta.last_page);
      }
      this.updateFlagMem = false;
      this.assignSlideOver = !this.assignSlideOver;
    },
    handleEditSection(section) {
      this.updateFlag = true;
      this.sectName = section.name;
      this.sectVisibility = section.show;
      this.updateId = section.id;
      this.sectionSlideOver = !this.sectionSlideOver;
    },
    handleCreateSect() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("name", this.sectName);
      formData.append("show", this.sectVisibility);

      userService
        .storeSection(formData)
        .then(() => {
          this.$Progress.finish();
          // clear binded data
          this.sectName = "";
          this.sectVisibility = "";
          this.getTeamMember();
          this.handleSection();
          this.toast.success("Section has been created successfully.");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Something went wrong! Could not create section!");
        });
    },
    handleUpdateSection() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("name", this.sectName);
      formData.append("show", this.sectVisibility);

      userService
        .storeUpdateSection(this.updateId, formData)
        .then(() => {
          this.$Progress.finish();
          this.getTeamMember();
          this.handleSection();
          this.toast.success("Update success");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Something went wrong could not update section!");
        });
    },
    handleDelSection(id) {
      this.$Progress.start();
      userService.delSection(id).then(() => {
        this.$Progress.finish();
        this.getTeamMember();
        this.toast.success("Section has been deleted Successfully");
      });
    },
    handleAssingSection() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("user_id", this.selectedPerson.id);
      formData.append("title_id", this.title.id);
      formData.append("leader_ship_section_id", this.section.id);

      userService
        .storeAssignLeader(formData)
        .then(() => {
          this.$Progress.finish();
          this.title = "";
          this.section = "";
          this.selectedPerson = "";
          this.getTeamMember();
          this.assignSlideOver = false;
          this.toast.success("Assign Success");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Something went wrong! could not assign!");
        });
    },
    handleReorderSection() {
      this.orderSection = !this.orderSection;
    },
    handleOrderSection() {
      this.$Progress.start();
      let orderSection = {};
      for (let i = 0; i < this.borderMembers.length; i++) {
        orderSection[this.borderMembers[i].id] = i + 1;
      }
      let formData = new FormData();
      formData.append("ids_order", JSON.stringify(orderSection));

      userService
        .storeReOrderSection(formData)
        .then(() => {
          this.$Progress.finish();
          this.getTeamMember();
          this.orderSection = false;
          this.toast.success("Reorder Section Successful!");
        })
        .catch(() => {
          this.$Progress.fail("Error! Cannot Re-order section!");
        });
    },
    handleReorderLeader(leader) {
      this.tempData = leader;
      this.orderLeader = !this.orderLeader;
    },
    handleOrderLeader() {
      this.$Progress.start();
      let orderSection = {};
      let leaderList = this.tempData.leader;
      for (let i = 0; i < leaderList.length; i++) {
        orderSection[leaderList[i].id] = i + 1;
      }
      let formData = new FormData();
      formData.append("ids_order", JSON.stringify(orderSection));
      userService
        .storeReOrderLeader(formData)
        .then(() => {
          this.$Progress.start();
          this.getTeamMember();
          (this.tempData = []), (this.orderLeader = false);
          this.toast.success("Reorder board member successful.");
        })
        .catch((error) => {
          this.$Progress.fail();
          console.log(error);
          this.toast.error("Error! Cannot reorder board member.");
        });
    },
    handleRemoveMember(id) {
      this.$Progress.start();
      userService
        .delMemberFromSection(id)
        .then(() => {
          this.$Progress.finish();
          this.getTeamMember();
          this.toast.success("Remove board member from section success.");
        })
        .catch((error) => {
          this.$Progress.fail();
          console.log(error);
          this.toast.error("Error! Cannot remove board member from section.");
        });
    },
    // get all member data on export function call
    async handleGetAllData(all_page) {
      this.$Progress.start();
      for (let page = 1; page <= all_page; page++) {
        this.params.set("page", page);
        await userService.getMembers(this.params).then((response) => {
          this.allMembers = this.allMembers.concat(response.data.data);
          all_page = response.data.meta.last_page;
        });
      }
      this.params.delete("page");
      this.$Progress.finish();
      console.log(all_page);
      console.log(this.allMembers);
    },
    handleEditMember(memberId) {
      this.tempUpdateID = memberId;
      this.assignSlideOver = true;
      this.updateFlagMem = true;
    },
    handleUpdatetitle() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("title_id", this.title.id);

      userService
        .storeUpdateTitle(this.tempUpdateID, formData)
        .then(() => {
          this.$Progress.finish();
          this.getTeamMember();
          this.title = "";
          this.assignSlideOver = false;
          this.updateFlagMem = false;
          this.toast.success("Update baord member title success!");
        })
        .catch((error) => {
          this.$Progress.fail();
          console.log(error);
          this.toast.error("Error! Cannot update board member title!");
        });
    },
  },
  computed: {
    dragOptions() {
      return {
        disabled: false,
        ghostClass: "ghost",
      };
    },
    filteredMember() {
      if (this.query === "") {
        return this.allMembers;
      } else {
        return this.allMembers.filter((person) => {
          return person.first_name
            .toLowerCase()
            .includes(this.query.toLowerCase());
        });
      }
    },
  },
  created() {
    this.$Progress.start();
    this.moment = moment;
    this.getTeamMember();
    this.getTitleList();
    userService.getMembers().then((response) => {
      this.memberMeta = response.data.meta;
    });
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: var(--light-blue);
}
</style>